import { type CustomTooltipProps } from "ag-grid-react"

import { Card, CardContent } from "~/components/reusable/Card"

import HeaderTooltip from "./HeaderTooltip"
import { formatName } from "~/utils/namingUtils"

const SellThroughRateTooltip = (props: CustomTooltipProps) => {
  if (props.location === "header") {
    return <HeaderTooltip {...props} />
  }
  return (
    <Card className="w-full">
      <CardContent>
        <div className="flex flex-col gap-1">
          <div>
            <b>Formula: </b>(Total {formatName("sale", true)}) / (Total {formatName("sale", true)} +
            Current stock level)
          </div>
          <div>
            <b>Calculation: </b>
            {props.value}
          </div>
        </div>
      </CardContent>
    </Card>
  )
}

export default SellThroughRateTooltip
